var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.391,
    height: 34.703,
    viewBox: "0 0 43.391 34.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M14221.6,12153.705h-19.423l-.5-.189a2.967,2.967,0,0,1-.942-4.783,3.023,3.023,0,0,1,.913-.621c.479-.182.606-.182,19.929-.182l19.448-.01.507.191a2.953,2.953,0,0,1,0,5.4l-.507.189Zm0-14.461h-19.423l-.5-.189a2.965,2.965,0,0,1-.942-4.781,3,3,0,0,1,.913-.623c.479-.182.606-.182,19.929-.182l19.448-.008.507.189a2.953,2.953,0,0,1,0,5.4l-.507.189Zm0-14.459h-19.423l-.5-.189a2.942,2.942,0,0,1-.029-5.406c.479-.18.606-.18,19.929-.18l19.448-.008.507.188a2.954,2.954,0,0,1,0,5.406l-.507.189Z",
    transform: "translate(-14199.898 -12119.002)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/Hamburger-menu.8576b8da7586dfe56b4c2cb7d09fd814.svg";
export { ForwardRef as ReactComponent };